import React, { createRef } from "react";
import { IconDetailOrder, MoveToInbox } from "../Mapbox/Popup";
import { forEach, findIndex, find, filter, round } from "lodash";
import { getStopLeft } from "../Mapbox/Utils";
import LabelComponent from "../Elements/LabelComponent";
import Icon from "@ant-design/icons";
import { Button, Divider } from "antd";
import { COLOR_DEFAULT, STATUS } from "../../constants";
import markerIcons from "../Markers/markerIcons";
import { convertMinutesToTime, getTranslation } from "../../utils/helper";
import "./index.scss";
import useRefDimensions from "../../hooks/useRefDimensions";
import * as turf from "@turf/turf";
import { useSelector } from "react-redux";

const ContentStop = ({
  stop,
  onClickStop,
  getStopLeft,
  unassignedStops,
  clickShowMoreStop,
  stepClicked: step,
  onClosePopup,
  stops,
  setting,
  order,
  canEdit,
}) => {
  const travelMins = convertMinutesToTime(step?.travelMins);
  const serviceMins = convertMinutesToTime(step?.duration);
  const waitingMins = convertMinutesToTime(step?.waitingMins);
  const workingMins = convertMinutesToTime(step?.workingMins);
  const distance = step?.distance ? round(step?.distance / 1000, 2) : "-";
  const status = STATUS.find(s => s.code === stop?.status);
  const driverName = stop?.driverName ?? "Driver";
  return (
    <div className="order-detail">
      <div className="header">
        <div className="left">{stop.orderRef || stop.orderCode}</div>
        <div className="right">
          {driverName && (
            <div className="driverInfo">
              <img src={markerIcons["driver"][stop.color]} alt={driverName} />
              {driverName}
            </div>
          )}
          <div className="close" onClick={onClosePopup}>
            X
          </div>
        </div>
      </div>
      <div className="content-top">
        <div className="type">{getTranslation(setting, "Orders", stop.type)}</div>
        <span className={`status orderStatus ${status?.code?.toLowerCase()}`}>
          {getTranslation(setting, "Orders", status?.name ?? "N/A")}
        </span>
        <div className="name">{stop.name}</div>
      </div>
      <div className="content-address">{stop.address}</div>
      <div className="content-link-detail">
        <a href={`/orders/${stop.orderId}`} target="_blank" rel="noopener noreferrer" className="link-details">
          {getTranslation(setting, "Common", "View Order Details")} {IconDetailOrder}
        </a>
      </div>
      <div className="content-main">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>{getTranslation(setting, "Orders", "Time Window")}</th>
              {step ? (
                <>
                  <th>{getTranslation(setting, "Orders", "Arrival Time")}</th>
                  <th>{getTranslation(setting, "Orders", "Finish Time")}</th>
                </>
              ) : (
                <th>{getTranslation(setting, "Orders", "Load")}</th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(stop.startTime || "") + " - " + (stop.endTime || "")}</td>
              {step ? (
                <>
                  <td>{step?.arrivalTime}</td>
                  <td>{step?.finishTime}</td>
                </>
              ) : (
                <td>{stop.load}</td>
              )}
            </tr>
          </tbody>
          {step && (
            <>
              <thead>
                <tr>
                  <th>{getTranslation(setting, "Orders", "Distance")}</th>
                  <th>{getTranslation(setting, "Orders", "Travel Time")}</th>
                  <th>{getTranslation(setting, "Orders", "Service Time")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{distance} km</td>
                  <td>{travelMins}</td>
                  <td>{serviceMins}</td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th>{getTranslation(setting, "Orders", "Working Time")}</th>
                  <th>{getTranslation(setting, "Orders", "Waiting Time")}</th>
                  <th>{getTranslation(setting, "Orders", "Load")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{workingMins}</td>
                  <td>{waitingMins}</td>
                  <td>{stop.load}</td>
                </tr>
              </tbody>
            </>
          )}
        </table>
        {order?.requiredSkills?.length > 0 && (
          <div className="OrderTypes">
            {order?.requiredSkills.map(type => (
              <div key={type} className="Type">
                {type}
              </div>
            ))}
          </div>
        )}
        {order?.labels?.length > 0 && (
          <div style={{ paddingBottom: "8px" }}>
            <LabelComponent labelIds={order?.labels || []} isEdit={false} />
          </div>
        )}
      </div>
      <div className="actions">
        {stop.routePlanType === "PDP" && (
          <Button
            onClick={() => {
              const stopT = getStopLeft(stop, stops);
              onClickStop(stopT);
              if (unassignedStops.includes(stopT)) {
                clickShowMoreStop(stopT);
              }
            }}>
            {stop.type === "pickup"
              ? getTranslation(setting, "Common", "Go to Delivery")
              : getTranslation(setting, "Common", "Go to Pickup")}{" "}
            <Icon component={MoveToInbox} />
          </Button>
        )}
        {/* {canEdit &&
          !["failed", "skipped", "completed"].includes(stop && stop.status) && (
            <a onClick={() => moveToUnscheduled(route, indexSteps)}>
              {getTranslation(setting, "Common", "Move to Unscheduled")}
              <Icon
                component={MoveToInbox}
                style={{
                  width: 14,
                  marginLeft: 5,
                }}
              />
            </a>
          )} */}
      </div>
    </div>
  );
};

const ContentStopUnassigned = ({ stop, onClickStop, getStopLeft, onClosePopup, stops, setting, order }) => {
  const status = STATUS.find(s => s.code === stop?.status);
  return (
    <div className="order-detail">
      {!!stop?.unscheduledReason && (
        <div className="unscheduledReason">
          <p>{stop?.unscheduledReason}</p>
        </div>
      )}
      <div className="header">
        <div className="left">{stop.orderCode}</div>
        <div className="right">
          <div className="close" onClick={onClosePopup}>
            X
          </div>
        </div>
      </div>
      <div className="content-top">
        <div className="type">{getTranslation(setting, "Orders", stop.type)}</div>
        <span className={`status orderStatus ${status?.code?.toLowerCase()}`}>
          {getTranslation(setting, "Orders", status?.name ?? "N/A")}
        </span>
        <div className="name">{stop.name}</div>
      </div>
      <div className="content-address">{stop.address}</div>
      <div className="content-link-detail">
        <a href={`/orders/${stop.orderId}`} target="_blank" rel="noopener noreferrer" className="link-details">
          {getTranslation(setting, "Common", "View Order Details")} {IconDetailOrder}
        </a>
      </div>
      <div className="content-main">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "25%" }}>{getTranslation(setting, "Orders", "Time Window")}</th>
              <th style={{ width: "25%" }}>{getTranslation(setting, "Orders", "Load")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(stop.startTime || "") + " - " + (stop.endTime || "")}</td>
              <td>{stop.load}</td>
            </tr>
          </tbody>
        </table>
        {order?.requiredSkills?.length > 0 && (
          <div className="OrderTypes">
            {order?.requiredSkills.map(type => (
              <div key={type} className="Type">
                {type}
              </div>
            ))}
          </div>
        )}
        {order?.labels?.length > 0 && (
          <div style={{ paddingBottom: "8px" }}>
            <LabelComponent labelIds={order?.labels || []} isEdit={false} />
          </div>
        )}
      </div>
      <div className="actions">
        {stop.routePlanType === "PDP" && (
          <Button
            onClick={() => {
              const stopT = getStopLeft(stop, stops);
              onClickStop(stopT);
            }}>
            {stop.type === "pickup"
              ? getTranslation(setting, "Common", "Go to Delivery")
              : getTranslation(setting, "Common", "Go to Pickup")}{" "}
            <Icon component={MoveToInbox} />
          </Button>
        )}
      </div>
    </div>
  );
};

const ContentNearHeader = () => {
  return (
    <div className="order-near-header">
      <Divider />
      <h4>Nearby Stops within 50m: </h4>
    </div>
  );
};

const ContentNearStop = ({ stop, onClickStop, index, driver }) => {
  return (
    <div
      className="order-near-content"
      onClick={() => {
        onClickStop(stop);
      }}>
      <div className="top">
        <div
          style={{
            border: `1px solid #${driver?.color || COLOR_DEFAULT}`,
            color: `#${driver?.color || COLOR_DEFAULT}`,
            textAlign: "center",
            minWidth: "24px",
            minHeight: "24px",
            lineHeight: "22px",
            fontSize: "14px",
            borderRadius: stop.type === "pickup" ? "50%" : 4,
          }}>
          {index + 1}
        </div>
        <p className="code">{stop.orderCode}</p>
      </div>

      <div className="bottom">{stop.address}</div>
    </div>
  );
};

const StopsClicked = ({
  stopClicked,
  stops,
  setting,
  routes: newRoutes,
  onClickStop,
  driverIdsHide,
  onClosePopup,
  orders,
  setShowStopContent,
  dimensionsChart,
}) => {
  const { user } = useSelector(state => state.auth);
  const canEdit = !user?.roles?.includes("user");
  let steps = [];
  const routes = {};
  const routesList = [];
  let handledOrderIds = [];
  const contents = [];
  const divRef = createRef();
  const dimensions = useRefDimensions(divRef);

  forEach(newRoutes, route => {
    const driver = route.driver;

    steps = steps.concat(route.steps);
    routes[driver._id] = [];

    if (driverIdsHide.includes(driver._id)) return;

    routesList.push(route);

    // Add handled steps
    const stepOrders = route.steps.map(s => s.orderId);
    let handledSteps = route.handledSteps ?? [];
    handledSteps = handledSteps.filter(step => {
      return step && !stepOrders.includes(step.orderId);
    });
    const handledStepIds = [];
    handledSteps.forEach(s => {
      const stop = find(stops, s1 => s1.orderId === s.orderId && s1.type === s.type.toLowerCase());
      if (stop) {
        routes[driver._id].push(stop);
        handledStepIds.push(s.orderId);
      }
      steps.push(s);
    });
    handledOrderIds = handledOrderIds.concat(handledStepIds);

    forEach(route.steps, s => {
      const stop = find(stops, s1 => s1.orderId === s.orderId && s1.type === s.type.toLowerCase());
      if (stop) {
        routes[driver._id].push(stop);
      }
    });
  });
  const orderIds = steps.map(s1 => s1.orderId);
  const unassignedStops = filter(stops, s => !orderIds.includes(s?.orderId) && !handledOrderIds.includes(s?.orderId));
  const stepClicked = find(
    steps,
    s => stopClicked?.orderId === s.orderId && stopClicked?.type === s.type.toLowerCase(),
  );

  const getContentStop = stop => {
    const order = orders.find(o => o._id === stopClicked.orderId);
    return (
      <ContentStop
        key={`${stop.orderId}-${stop.type}`}
        stop={stop}
        onClickStop={onClickStop}
        getStopLeft={getStopLeft}
        unassignedStops={unassignedStops}
        clickShowMoreStop={clickShowMoreStop}
        stepClicked={stepClicked}
        stops={stops}
        setting={setting}
        order={order}
        onClosePopup={onClosePopup}
        canEdit={canEdit}
      />
    );
  };

  const getContentNearStop = (stop, index, type, driver) => {
    return (
      <ContentNearStop
        key={`${stop.orderId}-${stop.type}-${index}`}
        stop={stop}
        onClickStop={onClickStop}
        setting={setting}
        index={index}
        stepType={type}
        driver={driver}
      />
    );
  };

  const clickShowMoreStop = stop => {
    const content = getContentStop(stop);
    setShowStopContent(content);
  };

  const getPopupStopUnassigned = stop => {
    const order = orders.find(o => o._id === stopClicked.orderId);
    return (
      <ContentStopUnassigned
        key={stop.id}
        stop={stop}
        setting={setting}
        onClickStop={onClickStop}
        getStopLeft={getStopLeft}
        unassignedStops={unassignedStops}
        onClosePopup={onClosePopup}
        clickShowMoreStop={clickShowMoreStop}
        stepClicked={stepClicked}
        stops={stops}
        order={order}
      />
    );
  };

  if (stopClicked?.lat) {
    const stopUnassignedIndex = findIndex(unassignedStops, s => s.id === stopClicked?.id);
    // Show only address for unassigned stop
    if (stopUnassignedIndex >= 0) {
      const order = orders.find(o => stopClicked.orderCode === o.orderCode);
      const s = {
        ...stopClicked,
        unscheduledReason: order?.unscheduledReason,
      };
      const popupStop = getPopupStopUnassigned(s);
      contents.push(popupStop);
    } else {
      const route = newRoutes?.find(r => r?.driver._id === stopClicked.driverId);
      const steps = (route?.handledSteps || []).concat(
        route?.steps?.filter(st => !st.orderId.includes("_start") && !st.orderId.includes("_end")) || [],
      );
      const popup = getContentStop(stopClicked);
      const center = [stopClicked.lng, stopClicked.lat];
      const radius = 0.05;
      const options = {
        steps: 10,
        units: "kilometers",
        properties: { foo: "bar" },
      };
      const circle = turf.circle(center, radius, options);
      contents.push(popup);
      const stopsSame = stops.filter(s => {
        if (s.driverId === stopClicked.driverId && s.id != stopClicked.id) {
          const pt = turf.point([s.lng, s.lat]);
          return turf.booleanPointInPolygon(pt, circle);
        }
        return false;
      });
      if (stopsSame.length > 0) contents.push(<ContentNearHeader key="nearby-header" />);
      stopsSame.forEach(ss => {
        const stepIndex = steps.findIndex(s => s?.orderId === ss?.orderId && s?.type.toLowerCase() === ss?.type);
        if (stepIndex > -1) {
          const content = getContentNearStop(ss, stepIndex, ss.type, route.driver);
          contents.push(content);
        }
      });
    }
  }

  return (
    <div className="StopsClicked" ref={divRef} style={{ height: "100%" }}>
      <div
        className="wrapper"
        style={{
          height: dimensions?.height - (dimensionsChart?.height ? dimensionsChart?.height + 44 : 0),
        }}>
        {contents}
      </div>
    </div>
  );
};

export default StopsClicked;
